<template>
    <div v-if="ad && ad.img" class="tw-flex tw-flex-col tw-justify-center">
        <a
            class="tw-text-center"
            :data-index="index"
            :href="ad.link"
            rel="noopener noreferrer"
            target="_blank">
            <span class="tw-text-[9px] tw-uppercase">Publicidade</span>
            <v-img
                alt="Advertisement"
                class="tw-mx-6"
                :src="ad.img" />
        </a>
        <v-divider
            class="tw-my-5"
            opacity="0.1"></v-divider>
    </div>
</template>

<script setup lang="ts">
    import type { Category } from '@/configs/categories';
    import { useAppStore } from '@/store/app';

    const props = defineProps<{
        category?: Category;
        index?: number;
    }>();

    const appStore = useAppStore();

    const categoryValue = props.category?.value?.toLowerCase() || '';
    const index = typeof props.index === 'number' ? props.index : appStore.getSingleAdIndex(categoryValue || 'news');

    const ads = computed(() => {
        return appStore.getAds;
    });

    const ad = computed(() => {
        if (!ads.value || !ads.value.length) {
            return null;
        }

        const categoryAds = categoryValue
            ? appStore.getAdsBySection(categoryValue)
            : ads.value;

        return categoryAds[index] || null;
    });
</script>

<style scoped></style>
